export default __webpack_public_path__ + "static/oracleotmgtm-e68d6a2da49f206edecb0feb31448ec3.svg";